import { MenuFilterState } from "./filter-state-type";

/* The core state that expresses user intent, can be persisted and restored from */
export type UserPreference = {
  ingredientIds: string[]; // The ingredients that the user has selected to avoid
  allergenIds: string[]; // The allergens that the user has selected to avoid
  preferenceId: string | null; // The preference that the user has selected to prefer
  tagIds: string[]; // The tags that the user has selected to highlight
  showMayContainAllergens: boolean; // Whether to show dishes that may contain allergens
  showCalories: boolean; // Whether to show calories
  showAllergenDetails: boolean; // Whether to show allergen details
};

// Default state when the user visits for the fist time.
export const NoPreference: UserPreference = {
  allergenIds: [],
  ingredientIds: [],
  preferenceId: null,
  tagIds: [],
  showMayContainAllergens: true,
  showCalories: false,
  showAllergenDetails: false,
};

export const createUserPreference = (
  menuFilterState: MenuFilterState
): UserPreference => {
  return {
    ingredientIds: menuFilterState.selectedIngredients
      // we store only the ingredient ids that the user has explicitly selected, not
      // the ones which have been disabled because of an allergen selection.
      // note that the ingredient state supports restoring bac a selected ingredient if the allergen is disabled.
      .filter(
        (i) => i.selected && i.selectedReason?.reason !== "contains-allergen"
      )
      .map((i) => i.igfdTaxIngredientId),
    allergenIds: menuFilterState.selectedAllergens.map(
      (a) => a.igfdTaxAllergenId
    ),
    preferenceId:
      menuFilterState.selectedPreference?.igfdTaxPreferenceId || null,
    tagIds: menuFilterState.selectedTags.map((t) => t.id),
    showMayContainAllergens: menuFilterState.showMayContainAllergens,
    showCalories: menuFilterState.showCalories,
    showAllergenDetails: menuFilterState.showAllergenDetails,
  };
};
